import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  & > span {
    margin-left: 2rem;
  }
`;
